import { VALIDATION_MESSAGES } from '@zorro/common-utils';
import * as yup from 'yup';

export const changeEmployeeCustomClassCategorySchema = yup.object({
  customAttribute: yup
    .string()
    .required(VALIDATION_MESSAGES.customClassCategoryRequired),
});

export type ChangeEmployeeCustomClassCategoryFormFields = yup.InferType<
  typeof changeEmployeeCustomClassCategorySchema
>;
